export enum TemplateCreationSourceEnum {
  TEMPLATE_STORE = 'template_store',
  EDITOR = 'editor',
  NOTIFICATION_DIRECTORY = 'notification_directory',
  ONBOARDING_DIGEST_DEMO = 'onboarding_digest_demo',
  ONBOARDING_IN_APP = 'onboarding_in_app',
  EMPTY_STATE = 'empty_state',
  DROPDOWN = 'dropdown',
}
